/**
 * A lot of these should probably be removed because mp-query-report-header
 * and other subcomponents should be emitting equivalent events with a report name superprop.
 *
 * As part of fast-edit, we will clean these up.
 */
export enum ProdTrackingEvent {
  DeprecatedUrlLoaded = `URL loaded with deprecated legend idxSelections`,

  RemoveFormulaClause = `Builder - Remove Formula Clause`,
  AddFormulaClause = `Builder - Add Formula Clause`,
  EditFormulaClause = `Builder - Edit Formula Clause`,

  SelectDashboard = `[Web Dash] Select Dashboard`,

  SelectTimeComparisonRange = `Time Comparison - Select Range`,
  ClearTimeComparisonRange = `Time Comparison - Clear Range`,

  ChartSort = `Chart Options - Sort`,

  // this was previously tracked as just "Add property filter", but upstream
  // the event prefix was removed which merged it with other "Add property filter" events
  PopoverAddFilter = `[Viewed popover] Add property filter`,
  PopoverZoomIn = `[Viewed popover] Zoom In`,
  PopoverViewUsers = `[Viewed popover] View Users`,
  PopoverViewEvents = `[Viewed popover] View Events`,
}

export const PRODUCTION_TRACKING_EVENTS = new Set<string>([...Object.values(ProdTrackingEvent)]);
